import {Container, Graphics, Text, AnimatedSprite} from 'pixi.js';
import {avatarDisc} from './Impact';

/**
 * The session lobby: a fresh game id, a big join QR, and the hunters who have
 * claimed their spot by publishing a join record. The game locks to them.
 */
const MONO = 'Courier New, monospace';

function text(str, size, x, y, color = 0xffffff, weight = '700') {
  const t = new Text({text: str, style: {fontFamily: MONO, fontSize: size, fontWeight: weight, fill: color, align: 'center'}});
  t.anchor.set(0.5);
  t.position.set(x, y);
  return t;
}

/**
 * makeLobby
 * @param {PIXI.Texture|null} qrTexture join QR
 * @param {Array<{handle:String,texture:PIXI.Texture|null}>} players
 * @param {Number|null} countdown seconds until start, once somebody joined
 */
export function makeLobby({qrTexture, players, countdown}) {
  const c = new Container();
  c.addChild(new Graphics().rect(0, 0, 800, 600).fill({color: 0x000000, alpha: 0.82}));

  c.addChild(text('DUCK HUNT · by firehose.games', 15, 400, 30, 0xfc6955, '400'));
  c.addChild(text('SCAN', 34, 400, 72, 0xfc6955));
  c.addChild(text('scan the code · sign in · point your camera here · tap the duck', 15, 400, 112, 0xbbbbbf, '400'));

  if (qrTexture) {
    c.addChild(new Graphics().rect(310, 140, 180, 180).fill(0xf0d9a8));
    const qr = new AnimatedSprite([qrTexture]);
    qr.width = 164;
    qr.height = 164;
    qr.position.set(318, 148);
    c.addChild(qr);
  }
  const label = players.length === 0 ? 'waiting for a hunter…' : 'hunter locked in';
  c.addChild(text(label, 18, 400, 396, 0xffe08a));

  const xs = players.length === 1 ? [400] : [300, 500];
  players.slice(0, xs.length).forEach((p, i) => {
    const disc = avatarDisc(p.texture, p.handle, 44);
    disc.position.set(xs[i], 468);
    disc.addChild(new Graphics().circle(0, 0, 47).stroke({width: 4, color: 0xffc73b}));
    c.addChild(disc);
    c.addChild(text('@' + p.handle, 14, xs[i], 524, 0xffffff, '400'));
  });

  if (countdown != null && players.length > 0) {
    c.addChild(text('starting in ' + countdown + '…', 20, 400, 566, 0xffffff));
  }
  return c;
}
